import React,{useEffect,useState} from 'react'
import './ActivateAccount.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';
import { FlipInXDiv,BounceInDiv } from '../../../components/Animations'
const Success = (props) => {


  const [backurl, setBackUrl] = useState(null)
  useEffect(() => {

    const queryParams = new URLSearchParams(window.location.search)
    const backbtnurl = queryParams.get("backbtnurl")
    const loginparam = queryParams.get("login")
    if (backbtnurl !== null && backbtnurl !== '') { 
      setBackUrl(`${backbtnurl.replace('/login.html','')}/oauth2/authorization/oracle`)
    }
  }, [])

  return <div className="activate-account-card">
    <div className="center">
 
      <div className="center-container">
        <div className="success-check">
          <FontAwesomeIcon icon={faCheck} color="white" size={'3x'} />
        </div>
      </div>
   
      <div className="center-container">
        <div className="success-title">Success!</div>
      </div>

      <hr className="divider-line" />
      <div className="success-inner">
        <br />
        <div className="success-text">Your account is now activated, but some applications requires an additional layer of security to login.</div>
        <br />
        <br />
        <div className="success-text">Let's get you logged in and setup your two-step verification.</div>
        <br />
        <br />
        <div className="success-login-container">
        {backurl ? <a href={backurl}><Button>Login</Button></a> : 
        <a href={props.defaultLoginURL}><Button>Login</Button></a> }
        </div>

        <br />
        <br />
      </div>
    </div>
  </div>
}

export default Success